module.exports = __webpack_public_path__ + "img/50.8c774453.jpg";